import { render, staticRenderFns } from "./EditPermissions.vue?vue&type=template&id=3a3d4bac&"
import script from "./EditPermissions.vue?vue&type=script&lang=js&"
export * from "./EditPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports